function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M295,503.78v-18h11.53l4.59,5.06v12.89Zm1-17v16l14.13,0V491.26l-4-4.44Z",
  transform: "translate(-295 -485.81)"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "15.83 5.75 10.71 5.75 10.71 0.69 11.71 0.69 11.71 4.75 15.83 4.75 15.83 5.75"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M299.06,500.13l-.4-8.08h1l.17,4.85c0,1,0,1.6,0,2.11h0c.19-.53.38-1.06.84-2.05l2.23-4.91H304l.17,4.65c0,1,0,1.75,0,2.28h0c.24-.7.48-1.34.79-2.07l2.17-4.86h1l-3.75,8.08h-1l-.22-4.59a21.45,21.45,0,0,1,0-2.33h0a21.71,21.71,0,0,1-.82,2.12l-2.25,4.8Z",
  transform: "translate(-295 -485.81)"
});

var SvgFilesListingWord = function SvgFilesListingWord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    fill: "#434546",
    "data-name": "Word Icon",
    viewBox: "0 0 16.13 17.97",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilesListingWord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/files_listing_word.cf88f68a.svg";
export { ForwardRef as ReactComponent };